import styled from 'styled-components';
import * as I from 'components/Icons';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import Typography, { TypeVariant } from 'shared/Typography';

const ShowOnDesktop = styled.div`
  display: block;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    display: none;
  } ;
`;

const ShowOnMobile = styled.div`
  display: none;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    display: block;
  } ;
`;

const ArrowWrap = styled.div`
  margin-right: 30px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    margin-right: 0px;
    transform: rotate(90deg);
  } ;
`;

const WrapSectionFour = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 200px;
  margin-bottom: 250px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    margin-top: 0px;
    margin-bottom: 50px;
  } ;
`;

const Title = styled.div`
  @media ${(p) => p.theme.queries.tabletAndDown} {
    max-width: 300px;
  } ;
`;

const Description = styled.div`
  padding-top: 30px;
  max-width: 430px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    padding-left: 25px;
    padding-right: 25px;
    max-width: 500px;
  } ;
`;

const RowSectionFour = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 100px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    flex-direction: column;
  } ;
`;

const PriceFour = styled.p`
  font-family: 'Epilogue';
  font-size: var(--font-size-header-01);
  line-height: var(--line-height-md);
  color: var(--color-white);
  margin-right: 20px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    margin-right: 0px;
    margin-bottom: 5px;
  } ;
`;

const PriceFourEarnings = styled.p`
  font-family: 'Epilogue';
  font-size: var(--font-size-header-01);
  line-height: var(--line-height-md);
  color: var(--color-white);
  margin-right: 20px;
  width: 230px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    margin-right: 0px;
    margin-bottom: 5px;
    width: auto;
  } ;
`;

const PriceTextFourWrap = styled.div`
  margin-right: 40px;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    margin-bottom: 35px;

    margin-right: 0px;
  } ;
`;

const CountWrap = styled.div`
  height: 200px;
  width: 100%;

  @media ${(p) => p.theme.queries.tabletAndDown} {
    height: 640px;
  } ;
`;

const SectionFour = () => (
  <WrapSectionFour>
    <Title>
      <Typography
        variant={TypeVariant.header02}
        as="h2"
        color="var(--color-white)"
        tablet={TypeVariant.subtitle01}
        textAlign="center"
      >
        Build and expand your brand
      </Typography>
    </Title>
    <Description>
      <Typography
        variant={TypeVariant.bodyLarge01}
        tablet={TypeVariant.body01}
        as="h2"
        color="var(--color-white)"
        textAlign="center"
      >
        Share your Solin page and immediately start driving your community to
        join your page on Solin
      </Typography>
    </Description>
    <VisibilitySensor partialVisibility>
      {({ isVisible }) => (
        <CountWrap>
          {isVisible ? (
            <RowSectionFour>
              <CountUp start={0} end={500} duration={3} delay={0}>
                {({ countUpRef }) => (
                  <PriceFour style={{ width: 90 }} ref={countUpRef}></PriceFour>
                )}
              </CountUp>

              <PriceTextFourWrap>
                <Typography
                  variant={TypeVariant.bodyLarge01}
                  as="p"
                  color="var(--color-gray-500)"
                  textAlign={{
                    default: 'left',
                    tablet: 'center',
                  }}
                >
                  Subscribers
                </Typography>
              </PriceTextFourWrap>

              <PriceFour>$25</PriceFour>

              <PriceTextFourWrap>
                <Typography
                  variant={TypeVariant.bodyLarge01}
                  as="p"
                  color="var(--color-gray-500)"
                  textAlign={{
                    default: 'left',
                    tablet: 'center',
                  }}
                >
                  Average Subscription <br /> Price on Solin{' '}
                </Typography>
              </PriceTextFourWrap>

              <ArrowWrap>
                <I.ArrowRightCreators />
              </ArrowWrap>
              <CountUp
                start={0}
                end={150000}
                duration={3}
                delay={0}
                separator=""
                prefix="$"
                formattingFn={(value) =>
                  `$${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                }
              >
                {({ countUpRef }) => (
                  <PriceFourEarnings ref={countUpRef}>$</PriceFourEarnings>
                )}
              </CountUp>

              <ShowOnDesktop>
                <PriceTextFourWrap>
                  <Typography
                    variant={TypeVariant.bodyLarge01}
                    as="p"
                    color="var(--color-gray-500)"
                    textAlign={{
                      default: 'left',
                      tablet: 'center',
                    }}
                  >
                    Annual
                    <br />
                    Earnings
                  </Typography>
                </PriceTextFourWrap>
              </ShowOnDesktop>
              <ShowOnMobile>
                <PriceTextFourWrap>
                  <Typography
                    variant={TypeVariant.bodyLarge01}
                    as="p"
                    color="var(--color-gray-500)"
                    textAlign={{
                      default: 'left',
                      tablet: 'center',
                    }}
                  >
                    Annual Earnings
                  </Typography>
                </PriceTextFourWrap>
              </ShowOnMobile>
            </RowSectionFour>
          ) : null}
        </CountWrap>
      )}
    </VisibilitySensor>
  </WrapSectionFour>
);

export default SectionFour;
